import axios from "../../config/AxiosConfig";
import { getLanguageId, getLanguageCode } from "../../helpers";

const queryParams = {
  params: {
    ...(getLanguageId() != null &&
      getLanguageCode() != null && {
        language: getLanguageId(),
        lng: getLanguageCode(),
      }),
  },
};

export const myInvestmentFetcher = (url) =>
  axios.get(url).then((response) => response.data.data.data);

export const getCardDetailFetcher = (url) =>
  axios.get(url).then((response) => response.data.data.data);

export const getDocumentDetailFetcher = (url) =>
  axios.get(url).then((response) => response.data.data.data);

export const getMyInvestmentsGraphFetcher = (url) =>
  axios.get(url).then((response) => response.data.data.data);

export const getInvestmentsChartFetcher = (url) =>
  axios.get(url, queryParams).then((response) => response.data.data.data);

export const getInvestmentUniqueCurrenciesFetcher = (url) =>
  axios.get(url).then((response) => response.data.data.data);

export const getInvestmentsColumnChartFetcher = (url) =>
  axios.get(url).then((response) => response.data.data.data);
